import type { LatLng } from './types';

/**
 * Stride-based downsample that always keeps the first/last vertex.
 * Cheap enough for huge ORS polylines on the main thread.
 */
export function thinLatLng(coords: LatLng[], maxPoints: number): LatLng[] {
  if (coords.length <= maxPoints || maxPoints < 3) return coords;
  const last = coords.length - 1;
  const step = last / (maxPoints - 1);
  const out: LatLng[] = new Array(maxPoints);
  for (let i = 0; i < maxPoints; i++) {
    const idx = i === maxPoints - 1 ? last : Math.round(i * step);
    out[i] = coords[idx]!;
  }
  return out;
}

/** ORS [lng, lat][] → LatLng[], optionally thinned for map/storage. */
export function thinLngLatPairs(
  pairs: Array<[number, number]>,
  maxPoints: number,
): LatLng[] {
  if (pairs.length === 0) return [];
  if (pairs.length <= maxPoints || maxPoints < 3) {
    return pairs.map(([lng, lat]) => ({ lat, lng }));
  }
  const last = pairs.length - 1;
  const step = last / (maxPoints - 1);
  const out: LatLng[] = new Array(maxPoints);
  for (let i = 0; i < maxPoints; i++) {
    const idx = i === maxPoints - 1 ? last : Math.round(i * step);
    const p = pairs[idx]!;
    out[i] = { lat: p[1], lng: p[0] };
  }
  return out;
}
